import React, { useRef, useState } from 'react'
import { Box, Button, FormLabel, TextField } from '@mui/material'
import { RoundedButton } from 'common/Button/Button'
import PropTypes from 'prop-types'
import * as yup from 'yup'

import AuthAPI from '../../../api/orbitV1/AuthAPI'
import { ERR_REQUIRED, ERR_UNEXPECTED } from '../../../constants/errors'

const LoginForm = (props) => {
  const { executeRecaptcha } = props

  const [email, setEmail] = useState('')
  const [errorMsg, setErrorMsg] = useState('')

  // block additional calls to login
  const allowLogin = useRef(true)

  const handleSignup = () => {
    window.location.href =
      'https://docs.google.com/forms/d/e/1FAIpQLScmJGge5OhrR03uL3H7VdmTEzIv-VC5M9q-R45_wk0iDLwEoA/viewform?usp=send_form'
  }

  const handleEmailSubmit = async () => {
    if (!allowLogin.current) {
      return
    }

    allowLogin.current = false
    // use an action based on type of activity (i.e. login) but include hostname
    // action only allows alphanumeric, underscore and slash, so need to replace
    // can use this to distinguish dev, staging and production without environments
    const action = `login_${window.location.hostname.replace(/(\.|-)/g, '_')}`
    const captchaToken = await executeRecaptcha(action)

    setErrorMsg('')
    if (!yup.string().email().isValid(email)) {
      setErrorMsg(ERR_REQUIRED)
      return
    }
    props.setEmail(email.trim())

    try {
      await AuthAPI.getOtpByEmail(email.trim(), captchaToken)
    } catch (error) {
      setErrorMsg(ERR_UNEXPECTED)
    }
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleEmailSubmit()
      }}
    >
      <Box sx={{ width: '100%', marginTop: '152px', marginBottom: '30px' }}>
        <FormLabel> Email Address</FormLabel>
        <TextField
          data-cy='emailField'
          fullWidth
          variant='standard'
          id='emailAddress'
          autoFocus
          placeholder='Key in your corporate email address'
          value={email}
          key='email'
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(errorMsg)}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '60px'
        }}
      >
        <Button
          data-cy='loginBtn'
          variant='filled'
          type='submit'
          sx={{ width: '100%' }}
        >
          Log In
        </Button>
        <RoundedButton
          variant='secondary'
          onClick={handleSignup}
          sx={{
            backgroundColor: 'transparent',
            width: '100%'
          }}
        >
          Don&apos;t have an account? Sign up!
        </RoundedButton>
      </Box>
    </form>
  )
}

LoginForm.propTypes = {
  executeRecaptcha: PropTypes.func,
  setEmail: PropTypes.func
}

export default LoginForm
